import { Checkbox as MuiCheckbox } from '@mui/material';
import { ReactElement } from 'react';

type CheckboxVariant = 'secondary' | 'critical';

export interface CheckboxProps {
  checked: boolean;
  handleChange?: () => void;
  disabled?: boolean;
  indeterminate?: boolean;
  readOnly?: boolean;
  variant?: CheckboxVariant;
}

export function Checkbox({
  checked,
  handleChange,
  disabled = false,
  indeterminate = false,
  readOnly = false,
  variant = 'secondary',
}: CheckboxProps): ReactElement {
  // Map variant to MUI color
  const color = variant === 'critical' ? 'error' : 'primary';

  // Handle onChange event to match handleChange signature
  const handleMuiChange = (_event: React.ChangeEvent<HTMLInputElement>) => {
    if (handleChange) {
      handleChange();
    }
  };

  return (
    <MuiCheckbox
      checked={checked}
      onChange={handleMuiChange}
      disabled={disabled}
      indeterminate={indeterminate}
      inputProps={{ readOnly }}
      color={color}
      size='small'
      sx={{
        padding: 0,
        width: 15,
        height: 15,
        '&.MuiCheckbox-root': {
          padding: 0,
        },
        '& .MuiSvgIcon-root': {
          fontSize: 18,
        },
      }}
      data-testid='checkbox'
    />
  );
}
